const privateRoutes = [

];

export default privateRoutes